module.exports = __webpack_public_path__ + "img/stock4.7b63f60d.png";